module.exports = "{{>base}}\n<hr>\n<button class=\"wide reset\">Reset timeline</button>\n"